import React from 'react';
import { Button, Modal } from '../../components';
import './ConfirmDialog.css';

/**
 * Small confirm dialog used for destructive actions ("Leave & forget me").
 * Wraps the shared <Modal variant="card" size="sm">.
 */
const ConfirmDialog = ({
  isOpen,
  title = 'Are you sure?',
  body,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmKind = 'primary',
  onConfirm,
  onCancel,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onCancel}
    variant="card"
    size="sm"
    title={title}
  >
    {body && <p className="confirm-dialog__body">{body}</p>}
    <div className="confirm-dialog__actions">
      <Button variant="ghost" onClick={onCancel}>
        {cancelLabel}
      </Button>
      <Button
        variant="primary"
        onClick={onConfirm}
        className={
          confirmKind === 'destructive' ? 'confirm-dialog__confirm' : undefined
        }
      >
        {confirmLabel}
      </Button>
    </div>
  </Modal>
);

export default ConfirmDialog;
